<app-patient-info *ngIf="patients && patients.length" [patients]="patients" [isHeaderVisible]="false" [isKiosk]="true">
</app-patient-info>
<div class="flex-label-container">
	<label id="confirm-number-labels-detail-text">{{ 'kiosk.labels' | translate: {'amount': labelQuantity} }}</label>
</div>
<div class="flex-button-container">
	<button id="cancel-print-btn" (click)="closeModal()">{{ 'kiosk.back' | translate }}</button>
	<button id="confirm-print-btn" (click)="handlePrint('all')" data-testid="print_all_button">{{ 'kiosk.print' | translate }}</button>
</div>
